import withTranslations from '../../utils/HighOrderComponent';
import { Row, Col } from 'react-bootstrap';
import InfoCard from './InfoCard';
import ChannelCard from './ChannelCard';

const Dashboard = (props) => {
  const { t, enums } = props || {},
    { ChannelCard: ChannelCardTranslations, InfoCard: InfoCardTranslations } =
      t || {},
    { ChannelStatus: ChannelStatusTranslation } = enums || {};

  return (
    <Row className="wrapper-fade-in">
      <Col md={6}>
        <InfoCard t={InfoCardTranslations} />
      </Col>
      <Col md={6}>
        <ChannelCard
          t={ChannelCardTranslations}
          ChannelStatus={ChannelStatusTranslation}
        />
      </Col>
    </Row>
  );
};

export default withTranslations(Dashboard, 'Dashboard');
